<template>
  <section id="noticias" class="secciones seccion-blanca text-center">
    <div class="container">
      <h1>
        <strong>Guía rápida para el usuario</strong>
      </h1>
      <p>Información importante a solo un click.</p>
      <div class="container padding-100">
        <div class="row">
          <div class="col-xl-3 col-lg-4 col-sm-6">
            <router-link :to="'/guia/0'" class="card-guia">
              <div class="icon-guia">
                <span class="material-icons-outlined">account_circle</span>
              </div>
              <div class="text-guia">
                <h3 class="letras-guia">Gestiona tu cuenta</h3>
                <p>Gestiona y edita los datos relacionados a tu cuenta.</p>
              </div>
            </router-link>
          </div>
          <div class="col-xl-3 col-lg-4 col-sm-6">
            <router-link :to="'/guia/1'" class="card-guia">
              <div class="icon-guia"><span class="material-icons-outlined">credit_card</span></div>
              <div class="text-guia">
                <h3 class="letras-guia">Medios de pago</h3>
                <p>Disfruta de nuestros medios de pago.</p>
              </div>
            </router-link>
          </div>
          <div class="col-xl-3 col-lg-4 col-sm-6">
            <router-link :to="'/guia/2'" class="card-guia">
              <div class="icon-guia"><span class="material-icons-outlined">search</span></div>
              <div class="text-guia">
                <h3 class="letras-guia">Seguimiento de tu compra</h3>
                <p>Realiza seguimiento de tu compra.</p>
              </div>
            </router-link>
          </div>
          <div class="col-xl-3 col-lg-4 col-sm-6">
            <router-link :to="'/guia/3'" class="card-guia">
              <div class="icon-guia">
                <span class="material-icons-outlined">local_shipping</span>
              </div>
              <div class="text-guia">
                <h3 class="letras-guia">Envío a domicilio</h3>
                <p>Recíbelo en la comodidad de tu casa.</p>
              </div>
            </router-link>
          </div>
          <div class="col-xl-3 col-lg-4 col-sm-6">
            <router-link :to="'/guia/4'" class="card-guia">
              <div class="icon-guia">
                <span class="material-icons-outlined">shopping_cart</span>
              </div>
              <div class="text-guia">
                <h3 class="letras-guia">Recojo en tienda</h3>
                <p>Compra online y ahorrate el costo de envío.</p>
              </div>
            </router-link>
          </div>
          <div class="col-xl-3 col-lg-4 col-sm-6">
            <router-link :to="'/guia/5'" class="card-guia">
              <div class="icon-guia"><span class="material-icons-outlined">headset_mic</span></div>
              <div class="text-guia">
                <h3 class="letras-guia">Servicio al Cliente</h3>
                <p>Conoce nuestro Servicio al Cliente.</p>
              </div>
            </router-link>
          </div>
          <div class="col-xl-3 col-lg-4 col-sm-6">
            <router-link :to="'/guia/6'" class="card-guia">
              <div class="icon-guia">
                <span class="material-icons-outlined">store_mall_directory</span>
              </div>
              <div class="text-guia">
                <h3 class="letras-guia">Nuestras tiendas</h3>
                <p>Revisa nuestras tiendas aquí.</p>
              </div>
            </router-link>
          </div>
          <div class="col-xl-3 col-lg-4 col-sm-6">
            <router-link :to="'/guia/7'" class="card-guia">
              <div class="icon-guia"><span class="material-icons-outlined">policy</span></div>
              <div class="text-guia">
                <h3 class="letras-guia">Términos y condiciones</h3>
                <p>Revisa aquí los términos y condiciones.</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import { config_settings } from '@/config.js';
export default {
  name: 'GuideModule',
  data() {
    return {};
  },
};
</script>

<style>
.best-products {
  margin-bottom: 10px;
}

#cotizacion {
  padding: 0px;
}

.padding-100 {
  padding: 50px 0;
}
a.card-guia {
  position: relative;
  top: 0;
  display: flex;
  padding: 15px;
  margin: 0 0 30px 0;
  height: 170px;
  background: rgb(223, 230, 234);
  color: rgb(0, 123, 255);
  border-radius: 10px;
  transition: all 0.35s;
}
a.card-guia:hover,
a.card-guia:focus,
a.card-guia:active {
  text-decoration: none;
  background: var(--primary-color);
  color: rgb(0, 86, 179);
  box-shadow: 0 10px 30px rgba(123, 142, 152, 0.5);
  top: -2px;
}
.icon-guia {
  display: flex;
  flex-direction: column;
  width: 25%;
}
.icon-guia i {
  margin: 40px auto 0 auto;
  font-size: 50px;
}
.icon-guia span {
  margin: 40px auto 0 auto;
  font-size: 50px;
}
.text-guia {
  display: flex;
  flex-direction: column;
  padding: 0 0 0 15px;
  width: 75%;
  overflow-y: auto;
}
.text-guia h3 {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 900;
}
.text-guia p {
  color: rgb(0, 123, 255);
  font-size: 14px;
  margin: 0 0 0 0 !important;
}

.letras-guia {
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
